import { Directive } from '@angular/core';
import { CheckboxRequiredValidator, NG_VALIDATORS } from '@angular/forms';

/**
 * This is basically just there to extends the selector of the already existing `CheckboxRequiredValidator`.
 *
 * @see https://github.com/angular/angular/issues/17495#issuecomment-354906393
 */
@Directive({
    selector:
        'pkp-toggle[required][formControlName],' +
        'pkp-toggle[required][formControl],' +
        'pkp-toggle[required][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ToggleRequiredValidator,
            multi: true
        }
    ],
    host: { '[attr.required]': 'required ? "" : null' }
})
export class ToggleRequiredValidator extends CheckboxRequiredValidator {}
